import { render, staticRenderFns } from "./ShippingAdd.vue?vue&type=template&id=48157554&"
import script from "./ShippingAdd.vue?vue&type=script&lang=js&"
export * from "./ShippingAdd.vue?vue&type=script&lang=js&"
import style0 from "./ShippingAdd.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports